import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '='
    },
    template: `
        <form-wrapper form="vm.form">
            <form-row error="vm.form.errors.categoryI18ns[vm.defaultLanguage].name">
                <label class="label">{{ 'questionCategory.Category name' | translate }} *</label>
                <div class="items">
                    <input ng-disabled="!vm.QuestionService.canManageQuestionRelatedData()" ng-model="vm.form.model.categoryI18ns[vm.defaultLanguage].name" type="text" class="form-control">
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.form.errors.parentCategoryId">
                <label class="label">{{ 'questionCategory.Parent category' | translate }}</label>
                <div class="items">
                    <select ng-disabled="!vm.QuestionService.canManageQuestionRelatedData()" ng-model="vm.form.model.parentCategoryId" class="form-control">
                        <option></option>
                        <option
                            ng-hide="vm.form.model.id === item.id"
                            ng-repeat-start="item in vm.list.items" value="{{ item.id }}">{{ item.activeI18n.name }}</option>
                        <option
                            ng-hide="vm.form.model.id === l2item.id"
                            ng-repeat-start="l2item in item.childCategories" value="{{ l2item.id }}">&emsp;{{ l2item.activeI18n.name }}</option>
                        <option
                            ng-hide="vm.form.model.id === l3item.id"
                            ng-repeat-start="l3item in l2item.childCategories" value="{{ l3item.id }}">&emsp;&emsp;{{ l3item.activeI18n.name }}</option>
                        <option ng-repeat-end ng-hide="true"></option>
                        <option ng-repeat-end ng-hide="true"></option>
                        <option ng-repeat-end ng-hide="true"></option>
                    </select>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.form.errors.status">
                <span class="label">{{ 'questionCategory.Status' | translate }}</span>
                <div class="items">
                    <ul class="checkboxes">
                        <li>
                            <label ng-repeat="item in vm.FORMS_CATEGORY_CATEGORY_ENUM.KEYS">
                                <input
                                    ng-disabled="!vm.QuestionService.canManageQuestionRelatedData()"
                                    ng-model="vm.form.model.status"
                                    value="{{ vm.FORMS_CATEGORY_CATEGORY_ENUM.KEYS[item] }}"
                                    type="radio"
                                > {{ vm.FORMS_CATEGORY_CATEGORY_ENUM.LABELS[item] }}
                            </label>
                        </li>
                    </ul>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
        </form-wrapper>
    </form>
    `
})
export default class {
    constructor (lodash, ListFactory, QuestionCategoryResource, FORMS_CATEGORY_QUESTION_ENUM, TokenService, QuestionService) {
        this.FORMS_CATEGORY_CATEGORY_ENUM = FORMS_CATEGORY_QUESTION_ENUM;
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.QuestionService = QuestionService;

        this.list = ListFactory.createWithPagination(QuestionCategoryResource.tree.bind(QuestionCategoryResource));
        this.list.fetch({ pageSize: 0 });

        if (this.form.model.parentCategoryId) {
            this.form.model.parentCategoryId = `${this.form.model.parentCategoryId}`;
        }
    }

    $onInit () {
        if (!this.form.model.status) {
            this.form.model.status = this.FORMS_CATEGORY_CATEGORY_ENUM.KEYS.ACTIVE;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/questioncategories/generaldata/index.js